const updateMembersLoading = (state, { payload }) => {
	state.membersLoading = payload;
};

export default updateMembersLoading;
